import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Header from "../common/Header";
import Footer from "../common/Footer";
import NotificationsPopup from "../common/NotificationsPopup";

import { getCurrentUser } from "../../actions/UserActions";
import * as Constants from "../../utilities/Constants";

export class ProductAccessDeniedPage extends Component {
    constructor (props) {
        super(props);
    }

    componentDidMount () {
        import("./_styles.scss");
        this.props.getCurrentUser();
    }

    getProductList () {
        const excludedProductNames = [Constants.ORGANIZATION_PRODUCT_SENTRI7DOCUMENTATION];

        const products = [];
        if (this.props.currentUser && this.props.currentUser != null) {
            return this.props.currentUser.UserProducts
                .filter(p => !excludedProductNames.includes(p.ProductName))
                .sort((a, b) => a.ProductName - b.ProductName);
        }
        return products;
    }

    render () {
        const userProducts = this.getProductList();
        const availableProducts = [];
        userProducts.forEach(p => availableProducts.push(
            <div key={p.ProductName}>
                <a href={p.Url} tabIndex="-1" style={{ marginLeft: "20px" }}>
                    {p.ProductName}®
                </a>
            </div>));

        return (
            <div className="container">
                <div id="productAccessDeniedPage">
                    <NotificationsPopup/>

                    <Header/>
                    <h2>Oops!</h2>
                    <div>
                        <p>It appears you are not authorized to access this product. If you believe you should have
                            access,
                            please contact your site administrator or call our Product Support team at (800)
                            341-0450.</p>
                        <p />
                        <p>To sign into other SoleSource products go to:</p>
                    </div>
                    <div id="productList">{availableProducts}</div>
                    <Footer/>
                </div>
            </div>
        );
    }
}

ProductAccessDeniedPage.defaultProps = {
    getCurrentUser: () => {}
};

ProductAccessDeniedPage.propTypes = {
    getCurrentUser: PropTypes.func
};

const mapStateToProps = state => ({
    currentUser: state.appState.currentUser
});

const mapDispatchToProps = (dispatch) => {
    return ({
        getCurrentUser: () => dispatch(getCurrentUser())
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductAccessDeniedPage);
